<template>
  <div class="news">
    <div class="news_ul">
      <div
        class="news_li"
        v-for="(item, index) in dataArr"
        :key="index"
        @click="todetail(item)"
      >
        {{ item.title }}
        <span>{{ happenTimeFun(item.time) }}</span>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @prev-click="handlePre"
        @next-click="handleNext"
        @current-change="changePage"
        :current-page="current_page"
        background
        layout="prev, pager, next"
        :page-count="total_page"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      total_page: 0,
      current_page: 1,
      page_size: 16,
      dataArr: [],
      jsondata: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $.ajax({
        url: "/static/json/news/list.json",
        type: "GET",
        success: (res) => {
          this.jsondata = res;
          let length = res.length;
          this.total_page = Math.ceil(length / this.page_size);
          this.dataArr = res.slice(0, this.page_size);
        },
      });
    },
    todetail(item) {
      // console.log(item);
      this.$router.push({
        path: "/details",
        query: {
          did: item.id,
          title: item.title,
          time: item.time,
        },
      });
    },
    handlePre(val) {
      this.current_page = val;
      let star = (this.current_page - 1) * this.page_size;
      let end = star + this.page_size;
      this.dataArr = this.jsondata.slice(star, end);
    },
    // 点击下一页
    handleNext(val) {
      this.current_page = val;
      let star = (this.current_page - 1) * this.page_size;
      let end = star + this.page_size;
      this.dataArr = this.jsondata.slice(star, end);
    },
    changePage(val) {
      this.current_page = val;
      let star = (this.current_page - 1) * this.page_size;
      let end = star + this.page_size;
      this.dataArr = this.jsondata.slice(star, end);
    },
    happenTimeFun(num) {
      //时间戳数据处理

      let date = new Date(num * 1000);

      //时间戳为10位需*1000，时间戳为13位的话不需乘1000

      let y = date.getFullYear();

      let MM = date.getMonth() + 1;

      MM = MM < 10 ? "0" + MM : MM; //月补0

      let d = date.getDate();

      d = d < 10 ? "0" + d : d; //天补0

      let h = date.getHours();

      h = h < 10 ? "0" + h : h; //小时补0

      let m = date.getMinutes();

      m = m < 10 ? "0" + m : m; //分钟补0

      let s = date.getSeconds();

      s = s < 10 ? "0" + s : s; //秒补0

      return y + "-" + MM + "-" + d;
    },
  },
};
</script>
<style lang="scss" scoped>
.news {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  .news_ul {
    width: 100%;
    margin-bottom: 30px;
    .news_li {
      border-bottom: 1px dashed #ccc;
      line-height: 36px;
      cursor: pointer;
      &::before {
        display: inline-block;
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #ccc;
        vertical-align: middle;
        margin-right: 10px;
      }
      span {
        float: right;
      }
    }
  }
}
</style>